module.exports = __WEBPACK_EXTERNAL_MODULE__clappr_core__;